import { type ISbRichtext } from '@storyblok/react'
import { type CookiePolicyStoryblok } from '~/types/generated'
import { type CookiePolicyProps } from './CookiePolicy.interface'

export const mapCookiePolicy = (story: CookiePolicyStoryblok): CookiePolicyProps => ({
  title: story.title,
  text: story.introText ?? '',
  statusHeading: story.statusHeading ?? '',
  essentialCookiesHeading: story.essentialCookiesHeading ?? '',
  essentialCookiesDescription: story.essentialCookiesDescription ?? '',
  analyticsCookiesHeading: story.analyticsCookiesHeading ?? '',
  analyticsCookiesDescription: story.analyticsCookiesDescription ?? '',
  personalisationCookiesHeading: story.personalisationCookiesHeading ?? '',
  personalisationCookiesDescription: story.personalisationCookiesDescription ?? '',
  richText: {
    richtext: story.richText as ISbRichtext
  }
})
